import { render, staticRenderFns } from "./TasinirHacizTalepEvrakForm.vue?vue&type=template&id=b1cab84e"
import script from "./TasinirHacizTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./TasinirHacizTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports